import * as repo from '../../../repositories/dropshipRepository'

const initialState = {
  loading: false,
  detailLoading: false,
  products: null,
  activeProduct: null,
  activeMfg: null,
  activeStep: 1,
  mfgList: null,
  modalViewType: 'product',
  query: ''
}

export const dropshipStore = {
  state: {...initialState},
  mutations: {
    resetState(state){
      const s = initialState
      Object.keys(s).forEach(key => {
        state[key] = s[key]
      })
    },
    stepForward(state){
      if(state.activeStep < 5) state.activeStep += 1
    },
    stepBack(state){
      if(state.activeStep > 1) state.activeStep -= 1
      state.activeMfg = null
    },
    setDropshipMfg(state, data){
      state.activeMfg = data.mfg
      if(!data.modal) state.activeStep += 1
    },
    setMfgPriceType(state, company){
      state.activeMfgPriceType = _.find(state.activeMfg.price_types, p => p.company == company)
    },
    setDropshipMfgList(state, data){
      state.mfgList = data.mfg_list
    },
    setDropshipLoading(state, status){
      state.loading = status
    },
    resetStep(state){
      state.activeStep = 1
      state.activeMfg = null
    },
    setProducts(state, data){
      state.products = data.products
    },
    setActiveProduct(state, product){
      state.modalViewType = 'product'
      state.activeProduct = product
    },
    setModalViewType(state, viewType){
      state.modalViewType = viewType
    },
    setQuery(state, query){
      state.query = query
    },
    clearQuery(state){
      state.query = ''
    },
    clearDropshipMfg(state){
      state.activeMfg = null
    },
    setDetailLoading(state, status){
      state.detailLoading = status
    },
    dropshipAppendProductData(state, data){
      // set base
      const ids = _.map(data.results.products, 'eclipse_id')
      const requestIds = _.map(data.params.products, p => parseInt(p))
      let set = _.filter(state.products, p => ids.includes(p.product_id))
    
      // Append Data for Meit API based returns
      set.forEach(p=>{
        p.eclipse_data = _.find(data.results.products, e => parseInt(e.eclipse_id) == p.product_id)
        p.pricing = _.find(data.results.pricing, e => parseInt(e.productId) == p.product_id)
      })
    }
  },
  actions:{
    stepForward(context){
      context.commit('stepForward')
    },
    stepBack(context){
      context.commit('stepBack')
    },
    async setDropshipMfg(context, data){
      context.commit('clearDropshipMfg')
      if(data.modal){
        this.dispatch('dropshipSetModalViewType', 'moreInfo')
        context.commit('setDetailLoading', true)
        data.fetchType = 'vendor_mins'
      }else{
        context.commit('setDropshipLoading', true)
        data.fetchType = 'all'
      }
      await repo.getVendorDetails(data)
      .then(res=>{
        data.mfg.details = res.data.vendor_details
      })
      .catch(error=>{
        context.commit('setDetailLoading', false)
        context.commit('setDropshipLoading', false)
        console.error("Error:", error);
      })
      if(data.mfg.details){
        context.commit('setDropshipMfg', data)
      }else{
        this.dispatch('setNotification', {message: 'No Dropship Vendor Data Found', messageType: 'danger'})
      }
      context.commit('setDropshipLoading', false)
      context.commit('setDetailLoading', false)
    },
    getDropshipMfgList(context){
      context.commit('setDropshipLoading', true)
      repo.getMfgList()
      .then(res=>{
        context.commit('setDropshipMfgList', res.data)
        context.commit('setDropshipLoading', false)
      })
      .catch(error=>{
        context.commit('setDropshipLoading', false)
        console.error("Error:", error);
      })
    },
    resetDropshipStep(context){
      context.commit('resetStep')
    },
    getDropshipMfgProducts(context, mfg){
      context.commit('setDropshipLoading', true)
      repo.getMfgProducts(mfg)
      .then(res=>{
        context.commit('setProducts', res.data.results)
        this.dispatch('setFilters', res.data.results)
        context.commit('setDropshipLoading', false)
      })
      .catch(error=>{
        context.commit('setDropshipLoading', false)
        console.error("Error:", error);
      })
    },
    setDropshipActiveProduct(context, product){
      context.commit('setActiveProduct', product)
    },
    dropshipSetModalViewType(context, viewType){
      context.commit('setModalViewType', viewType)
    },
    dropshipUpdateQuery(context, query){
      context.commit('setQuery', query)
    },
    dropshipClearQuery(context){
      context.commit('clearQuery')
    },
    dropshipCartCheck(context, mfg){
      repo.cartCheck(mfg)
      .then(res=>{
        const id = res.data.dropship_cart_id
        if(id){
          this.dispatch('getCart', id)
        }else{
          return
        }
      })
      .catch(error=>{
        console.error("Error:", error);
        return
      })
    },
    dropshipAppendProductData(context, data){
      context.commit('dropshipAppendProductData', data)
    }
  },
  getters: {
    dropshipStep: state => {return state.activeStep},
    dropshipMfg: state => {return state.activeMfg},
    dropshipMfgList: state => {return state.mfgList},
    dropshipLoading: state => {return state.loading},
    dropshipDetailLoading: state => {return state.detailLoading},
    dropshipMfgProducts: state => {return state.products},
    dropshipActiveProduct: state => {return state.activeProduct},
    dropshipModalViewType: state => {return state.modalViewType},
    dropshipQuery: state => {return state.query}
  }
}